/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SearchMaintenanceRequestsResponse { 
    id: string;
    createdDate: string;
    status: string;
    maintenanceType: string;
    facilityName?: string | null;
    serialNumber: string;
    serviceCenterName?: string | null;
    error?: string | null;
    warrantyType: string;
}

